<template>
  <div class="overflow-y-scroll">
    <h3>Add Info</h3>
    <section>
      <div class="form-inline">
        <label>Title:</label>
        <div>
          <input type="text" placeholder="Title" v-model="editTitle" />
        </div>
      </div>
      <div class="form-inline">
        <label>Content:</label>
        <div>
          <textarea rows="3" v-model="editContent" />
        </div>
      </div>
      <div class="form-inline">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
        >Add Info</spinnerButton>
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading"],
  components: {
    spinnerButton
  },
  data() {
    return {
      editTitle: null,
      editContent: null
    };
  },
  created: function() {
    this.initData();
  },
  methods: {
    initData: function() {
      this.editName = null;
      this.editTitle = null;
    },
    buttonClick: function() {
      this.$emit("buttonClick", this.editTitle, this.editContent);
    }
  }
};
</script>
